import { Doughnut } from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme,
  CardActions,
  Button
} from '@material-ui/core';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIcon from '@material-ui/icons/Phone';
import TabletIcon from '@material-ui/icons/Tablet';


//Redux
import { useSelector, useDispatch } from "react-redux";



const TrafficByDevice = (props) => {
  const theme = useTheme();
  const { calculator: { principal, rate, term, rateTerm, total, amortization } } = useSelector(state => state.data);


  const data = {
    datasets: [
      {
        data: [63, 15, 22],
        backgroundColor: [
          colors.indigo[500],
          colors.red[600],
          colors.orange[600]
        ],
        borderWidth: 8,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white
      }
    ],
    labels: ['Desktop', 'Tablet', 'Mobile']
  };

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  const devices = [
    {
      title: 'Desktop',
      value: 63,
      icon: LaptopMacIcon,
      color: colors.indigo[500]
    },
    {
      title: 'Tablet',
      value: 15,
      icon: TabletIcon,
      color: colors.red[600]
    },
    {
      title: 'Mobile',
      value: 23,
      icon: PhoneIcon,
      color: colors.orange[600]
    }
  ];

  return (
    <Card {...props}>
      <CardHeader title="Loan Calculator" />
      <Divider />
      <CardContent>
        <Box
          sx={{
            display: 'block',
            justifyContent: 'center',
            pt: 1
          }}
        >
            <Box
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="primary"
                variant="body2"
              >
                Principal
              </Typography>
              <Typography
                 style={{ color: colors.orange[600] }}
                 variant="h4"
              >
               ₱ {principal}
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="primary"
                variant="body2"
              >
                Rate
              </Typography>
              <Typography
                 style={{ color: colors.orange[600] }}
                 variant="h5"
              >
               {rate}% / {rateTerm}
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="primary"
                variant="body2"
              >
                Payment Term
              </Typography>
              <Typography
                 style={{ color: colors.orange[600] }}
                 variant="h5"
              >
               {term} {rateTerm === 'Weekly'? 'Week/s' : rateTerm === 'Monthly' ? 'Month/s' : 'Semi-monthly'  }
              </Typography>
              <Typography
                variant="caption"
              >
              TO PAY
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="primary"
                variant="body1"
              >
                Total
              </Typography>
              <Typography
                 style={{ color: colors.orange[600] }}
                 variant="h4"
              >
               ₱ {total}
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1,
                textAlign: 'center'
              }}
            >
              <Typography
                color="primary"
                variant="body1"
              >
              {rateTerm} Due
              </Typography>
              <Typography
                 style={{ color: colors.red[900] }}
                 variant="h3"
              >
               ₱ {amortization}
              </Typography>
            </Box>
        </Box>
      </CardContent>
      <Divider className="mb-2"/>
      <CardActions className="center-element m-1">
        <Button className="mb-1" variant="outlined" size="small" color="success">Proceed Application</Button>
      </CardActions>
    </Card>
  );
};

export default TrafficByDevice;
